export default __webpack_public_path__ + "static/media/telegram.1a68ac14.svg";